import React from "react";
import { X, Trash2, Plus, Minus, ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { brl } from "@/lib/format";
import { useNavigate } from "react-router-dom";

export default function CartDrawer() {
  const { items, update, remove, subtotal, open, setOpen, count } = useCart();
  const nav = useNavigate();
  const threshold = 199;
  const progress = Math.min(100, (subtotal / threshold) * 100);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60]" data-testid="cart-drawer">
      <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)} />
      <aside className="absolute right-0 top-0 bottom-0 w-full sm:w-[420px] bg-white shadow-xl flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#F9E1E8]">
          <h3 className="font-serif text-xl text-[#4A3B40]">Seu carrinho ({count})</h3>
          <button onClick={() => setOpen(false)} data-testid="cart-close"><X className="w-5 h-5" /></button>
        </div>

        {subtotal < threshold ? (
          <div className="px-5 pt-4">
            <p className="text-xs text-[#4A3B40]">Faltam <strong className="text-[#C9708B]">{brl(threshold - subtotal)}</strong> para o frete grátis!</p>
            <div className="w-full bg-[#F9E1E8] rounded-full h-2 overflow-hidden mt-1.5">
              <div className="bg-[#E8A0B4] h-full transition-all duration-500 rounded-full" style={{width: `${progress}%`}} />
            </div>
          </div>
        ) : (
          <div className="px-5 pt-4"><p className="text-sm text-[#7DBE9E] font-semibold">🎉 Você ganhou frete grátis!</p></div>
        )}

        <div className="flex-1 overflow-y-auto px-5 py-4 space-y-4">
          {items.length === 0 ? (
            <div className="h-full flex flex-col items-center justify-center text-center text-[#8C7A80] py-16">
              <ShoppingBag className="w-14 h-14 text-[#E8A0B4] mb-3" />
              <p className="font-serif text-lg text-[#4A3B40]">Seu carrinho está vazio</p>
              <p className="text-sm">Que tal começar a encantar?</p>
            </div>
          ) : items.map((it, idx) => {
            const price = it.product.promo_price || it.product.price;
            return (
              <div key={idx} className="flex gap-3 pb-4 border-b border-[#F9E1E8]" data-testid={`cart-item-${idx}`}>
                <img src={(it.product.images||[])[0] || "https://placehold.co/80x80/F9E1E8/C9708B?text=L"} alt="" className="w-20 h-20 rounded-xl object-cover bg-[#FFF9FA]" />
                <div className="flex-1 min-w-0">
                  <p className="font-serif text-sm text-[#4A3B40] line-clamp-2">{it.product.name}</p>
                  <p className="text-[#C9708B] font-bold mt-1">{brl(price)}</p>
                  <div className="flex items-center justify-between mt-2">
                    <div className="flex items-center border border-[#F9E1E8] rounded-full">
                      <button onClick={() => update(idx, it.quantity - 1)} className="w-7 h-7 flex items-center justify-center text-[#C9708B]"><Minus className="w-3 h-3" /></button>
                      <span className="w-6 text-center text-sm">{it.quantity}</span>
                      <button onClick={() => update(idx, it.quantity + 1)} className="w-7 h-7 flex items-center justify-center text-[#C9708B]"><Plus className="w-3 h-3" /></button>
                    </div>
                    <button onClick={() => remove(idx)} className="text-[#8C7A80] hover:text-[#E57373]" data-testid={`cart-remove-${idx}`}><Trash2 className="w-4 h-4" /></button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="border-t border-[#F9E1E8] p-5 space-y-3">
          <div className="flex justify-between text-sm"><span className="text-[#8C7A80]">Subtotal</span><span className="font-semibold text-[#4A3B40]">{brl(subtotal)}</span></div>
          <button
            disabled={items.length === 0}
            onClick={() => { setOpen(false); nav("/checkout"); }}
            className="w-full btn-lara disabled:opacity-50"
            data-testid="cart-checkout-button"
          >Finalizar compra</button>
          <button onClick={() => { setOpen(false); nav("/carrinho"); }} className="w-full btn-lara-outline" data-testid="cart-view-page">Ver carrinho completo</button>
        </div>
      </aside>
    </div>
  );
}
